import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';
import ContactForm from '../components/ContactForm';
import Obfuscate from 'react-obfuscate';

import social_image from '../images/social.png';

import { Trans, useTranslation } from 'gatsby-plugin-react-i18next';
import { useI18next } from 'gatsby-plugin-react-i18next';

function ContactPage() {
  const { t } = useTranslation();
  const c = useI18next();
  return (
    <Layout>
      <SEO
        keywords={[`contact`, 'Diego Valle', 'Diego Valle-Jones']}
        title={t('Contact')}
        description={t("I always enjoy hearing from my visitors. Don't hesitate to use the form to send me an email.")}
        image={social_image}
      />
      <main className="flex flex-col flex-1 md:justify-center max-w-4xl mx-auto px-4 py-8 md:p-8 w-full">
        <section className="text-center">
          <h1>
            <Trans>Contact</Trans>
          </h1>
          <p className="text-left">
            <Trans i18nKey="contact_text">
              I enjoy reading interesting and insightful comments from my visitors. Nothing makes me happier than
              helping people out, so don’t hesitate to use the form below to get in touch with me or email me directly
              at <Obfuscate linkText="" email="diego@diegovalle.net" /> (se habla español).
            </Trans>
          </p>
          <ContactForm language={c.language} name={t('John Smith')} t={t} email={t('example@example.com')} />
          <hr className="p-5" />
        </section>
        <section className="text-left">
          <div>
            <h3 className="text-3xl">
              <Trans>Other ways to get in touch:</Trans>
            </h3>
            <br />
            𝕏 (twitter):{' '}
            <a href="https://x.com/diegovalle" rel="me">
              @diegovalle
            </a>
          </div>
          <br />
          <div className="">
            <h4 className="font-bold my-3">
              <Trans>Around the web:</Trans>
            </h4>
            <ul class="max-w-md space-y-1list-none list-inside">
              <li>
                GitHub:{' '}
                <a href="https://github.com/diegovalle" rel="me">
                  diegovalle
                </a>
              </li>
              <li>
                Facebook:{' '}
                <a href="https://facebook.com/diegovalle" rel="me">
                  diegovalle
                </a>
              </li>
              <li>
                Linkedin:{' '}
                <a href="https://www.linkedin.com/in/diegovalle" rel="me">
                  diegovalle
                </a>
              </li>
              <li>
                Gitlab:{' '}
                <a href="https://gitlab.com/diegovalle" rel="me">
                  diegovalle
                </a>
              </li>
              <li>
                Tumblr:{' '}
                <a href="https://diegovalle.tumblr.com/" rel="me">
                  diegovalle
                </a>
              </li>
              <li>
                Vimeo:{' '}
                <a href="https://vimeo.com/diegovalle" rel="me">
                  diegovalle
                </a>
              </li>
              <li>
                Flickr:{' '}
                <a href="https://www.flickr.com/diegovalle/" rel="me">
                  diegovalle
                </a>
              </li>
              <li>
                Youtube:{' '}
                <a href="https://www.youtube.com/@diegovalley" rel="me">
                  @diegovalley
                </a>
              </li>
              <li>
                About.me:{' '}
                <a href="https://about.me/diegovalle" rel="me">
                  diegovalle
                </a>
              </li>
              <li>
                Medium:{' '}
                <a href="https://medium.com/@diegovalle" rel="me">
                  diegovalle
                </a>
              </li>
              <li>
                Manifold:{' '}
                <a href="https://manifold.markets/DiegoValle" rel="me">
                  @DiegoValle
                </a>
              </li>
              <li>
                SoundCloud:{' '}
                <a href="https://soundcloud.com/diegovalle" rel="me">
                  diegovalle
                </a>
              </li>
              <li>
                Pinterest:{' '}
                <a href="https://www.pinterest.com/diegovalley/" rel="me">
                  diegovalley
                </a>
              </li>
            </ul>
          </div>
        </section>
      </main>
    </Layout>
  );
}

export default ContactPage;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { ns: { in: ["common", "contact", "header"] }, language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
